import { useClubMembershipContext } from '../contexts/ClubMembershipContext'

/**
 * The signed-in member's paid standing, or null for someone who hasn't taken
 * one. `null` is a normal state here, not an error — most visitors have no
 * membership and the API says so with a null rather than a 404. A null left
 * behind by a fetch that FAILED comes with `failed: true`, so a gate can tell
 * the two apart (see ClubMembershipContext).
 *
 * Now a thin read of ClubMembershipProvider rather than its own fetch, so the
 * clubhouse gate and the screen inside it always agree and only one request is
 * made. The shape is unchanged, so no call site moved.
 */
export function useClubMembership() {
  return useClubMembershipContext()
}
